import React from "react";

interface MobilePaginationProps {
  currentPage: number;
  totalCount: number;
  pageSize: number;
  onPageChange: (page: number) => void;
}

export const MobilePagination: React.FC<MobilePaginationProps> = ({
  currentPage,
  totalCount,
  pageSize,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalCount / pageSize);
  if (totalPages <= 1) return null;

  return (
    <div
      className="
        fixed bottom-0 left-0 right-0 z-50
        bg-white/95 backdrop-blur-sm
        border-t border-gray-200
        px-4 py-3 
        flex items-center justify-between
        shadow-[0_-2px_6px_rgba(0,0,0,0.06)]
      "
    >
      {/* Prev */}
      <button
        type="button"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className="
          px-4 py-2 
          bg-gray-100 rounded-lg text-sm font-medium 
          disabled:opacity-40 disabled:cursor-not-allowed
          active:scale-95 transition
        "
      >
        Prev
      </button>

      {/* Page indicator */}
      <div className="text-sm font-semibold text-gray-800">
        {currentPage} / {totalPages}
      </div>

      {/* Next */}
      <button
        type="button"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        className="
          px-4 py-2 
          bg-gray-100 rounded-lg text-sm font-medium 
          disabled:opacity-40 disabled:cursor-not-allowed
          active:scale-95 transition
        "
      >
        Next
      </button>
    </div>
  );
};
